import HttpClient from '@/utility/http-client';

export default {
    uploadFile(file: File, fileType: string = 'bill') {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('fileType', fileType);
        
        return HttpClient.instance().post('/api/files/upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    deleteFile(filePath: string) {
        return HttpClient.instance().delete('/api/files/delete/', {
            data: { filePath }
        });
    }
};
